import styled from 'styled-components';

const ConversionPanelContainer = styled.div`
  padding: 29px 40px;
  box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
  background: #fff;
  margin: 46px auto 61px;
  position: relative;
  display: flex;
  align-items: center;
  background-size: cover;
  flex-wrap: wrap !important;
  ${({ backgroundImg }) =>
    backgroundImg &&
    `
  background-image: url('${backgroundImg}');
    `}

  .blog-conversion-panel--main {
    display: flex;
    align-items: center;
    flex: 1;

    .blog-conversion-panel--photo {
      width: 70px !important;
      height: 70px !important;
      margin-right: 20px;
    }

    .blog-conversion-panel--content {
      flex: 1;

      .blog-conversion-panel--heading-kicker {
        font-weight: bold;
        font-size: 20px;
        line-height: 120%;
        letter-spacing: -0.01em;
        ${({ textColor }) =>
          textColor &&
          `
        color: ${textColor};
        `}
        margin: 0;
      }

      .blog-conversion-panel--heading {
        font-weight: bold !important;
        font-size: 20px;
        line-height: 150%;
        ${({ textColor }) =>
          textColor &&
          `
        color: ${textColor};
        `}
        margin: 4px 0 0;
      }

      p {
        ${({ textColor }) =>
          textColor &&
          `
        color: ${textColor};
        margin: 0;
        `}
      }
    }
  }

  .blog-conversion-panel--button {
    display: flex;
    align-items: top;
    height: fit-content;

    a {
      height: 48px;
      font-weight: bold;
      font-size: 16px;
      line-height: 110%;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;

    .blog-conversion-panel--main {
      flex-direction: column;
      align-items: flex-start;
      .blog-conversion-panel--content {
        margin-top: 20px;
        width: 100%;
        .blog-conversion-panel--heading-kicker,
        .blog-conversion-panel--heading {
          font-size: 16px;
        }
      }
    }

    .blog-conversion-panel--button {
      margin-top: 20px;
    }
  }
`;

const FormContainer = styled.div`
  width: 100%;
  background-color: transparent;
  > div {
    color: white;
    padding-top: 0;
  }
  .section-hero--notification {
    color: white;
  }
  .signup-form--form {
    padding: 10px 0px 0px !important;
    background-color: transparent !important;
    .ant-form-item:nth-child(1) {
      width: 100%;
      .text-field-wrapper .text-field-input {
        width: 95%;
      }
    }
  }
  @media (max-width: 768px) {
    > div {
      padding: 0;
    }
    .text-field-wrapper .text-field-input {
      width: 100% !important;
    }
    .slick-list {
      height: auto !important;
    }
  }
`;

export { ConversionPanelContainer, FormContainer };
